export const channels = [
  {
    slug: "yu-le",
    name: "娱乐爆料",
    description: "聚焦行业内部动态与一线爆料，第一时间梳理事件脉络与官方回应。",
    icon: "ri-fire-line",
  },
  {
    slug: "ming-xing",
    name: "明星动态",
    description: "工作室动态、公开行程与维权进展，记录艺人与团队的每一步动作。",
    icon: "ri-star-line",
  },
  {
    slug: "ying-shi",
    name: "影视综艺",
    description: "剧集口碑、综艺剪辑与制作幕后，还原内容背后的真实创作过程。",
    icon: "ri-film-line",
  },
  {
    slug: "wang-luo",
    name: "网络热议",
    description: "热搜话题、平台治理与网友讨论，观察舆论场的情绪走向与信息真伪。",
    icon: "ri-chat-3-line",
  },
  {
    slug: "she-hui",
    name: "社会热点",
    description: "城市生活、公共话题与消费观察，关注与你我日常相关的真实变化。",
    icon: "ri-earth-line",
  },
];

export const articles = [
  {
    id: "a1001",
    slug: "agency-restructure-contracts",
    title: "某头部经纪公司被曝内部重组，多位艺人合约同步调整",
    summary:
      "有从业者向本频道透露，该公司近两个月陆续完成业务线拆分，艺人合约与宣传团队同步重新划分，官方尚未发布正式声明。",
    channelSlug: "yu-le",
    channelName: "娱乐爆料",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20dark%20stage%20with%20warm%20red%20spotlight%20beams%20and%20floating%20paper%20documents%2C%20cinematic%20moody%20atmosphere%2C%20soft%20grain%2C%20editorial%20magazine%20photography%2C%20no%20people%2C%20deep%20shadow%20and%20glowing%20highlight%20contrast&width=800&height=600&seq=bl-cover-1001&orientation=landscape",
    author: "本频道编辑部",
    publishedAt: "2026-09-10 09:20",
    readTime: "4 分钟",
    tags: ["内部重组", "合约调整", "行业动态"],
    views: 128400,
    hot: true,
    editorPick: true,
    content: [
      "9 月 10 日上午，多位不愿具名的从业者向本频道透露，一家长期活跃在剧集与综艺领域的经纪机构，近期完成了内部业务线的拆分与重组。据描述，原有的艺人统筹、宣传推广与商务对接三条业务线被重新划分，部分团队的汇报关系出现调整。",
      "爆料人提到，本次调整并非临时决定，相关方案在此前两个月内已多次内部沟通。伴随组织架构变化，部分艺人的合约期限、分成比例与宣传资源分配也同步进入重新协商阶段，涉及的艺人数量在十位上下。",
      "不过，截至发稿时，该公司官方渠道尚未就上述内容发布任何正式声明。本频道已通过公开邮箱向对方发送采访函，暂未获得回复。按照行业惯例，此类调整的最终结果通常需要一段时间才会正式对外公布。",
      "需要提醒的是，组织架构调整在内容行业并不罕见，它往往与项目周期、平台采购节奏以及团队人员流动有关。对于网络流传的各类细节，建议读者以官方公告为准，避免在信息不完整的情况下过度解读。",
    ],
  },
  {
    id: "a1002",
    slug: "summer-drama-reviews-diverge",
    title: "暑期档剧集口碑两极分化，制作方回应剧本争议",
    summary:
      "同一部剧在开分后出现明显分化，支持者称赞表演细腻，质疑者认为中段节奏拖沓。制作方在采访中首次回应了剧本打磨周期的问题。",
    channelSlug: "ying-shi",
    channelName: "影视综艺",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20vintage%20cinema%20projector%20beam%20crossing%20a%20dark%20room%20with%20warm%20amber%20dust%20particles%2C%20filmic%20texture%2C%20no%20people%2C%20soft%20warm%20tones%2C%20editorial%20culture%20magazine%20aesthetic%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=bl-cover-1002&orientation=landscape",
    author: "影视观察组",
    publishedAt: "2026-09-10 08:05",
    readTime: "5 分钟",
    tags: ["暑期档", "剧集口碑", "剧本打磨"],
    views: 96400,
    hot: true,
    editorPick: false,
    content: [
      "随着暑期档进入尾声，围绕几部重点剧集的讨论仍在持续。数据显示，其中一部都市题材剧集在开分后的 48 小时内，评价呈现明显的两极分化：高分评价集中在演员的表演细节与镜头语言，低分评价则更多指向中段叙事节奏与部分配角线的处理。",
      "在近日的一场公开活动中，该剧制作方首次就剧本争议作出回应。负责人表示，项目从立项到开机的时间相对紧张，剧本在拍摄期间做过结构调整，其中就包括中段几集的内容合并，这在一定程度上影响了叙事的连贯性。",
      "「我们并不回避这些问题。」该负责人同时提到，团队已经在筹备的番外内容中尝试补足部分人物动机，希望给观众一个更完整的交代。平台方面暂未透露是否会有剪辑版本上线。",
      "从行业角度看，剧集口碑分化背后往往是创作周期、平台排播与市场预期三者之间的博弈。对观众而言，选择在完整观看后给出评价，或许比开分当天的即时打分更能反映作品的真实水准。",
    ],
  },
  {
    id: "a1003",
    slug: "set-photo-rumor-clarified",
    title: "网络热传的「剧组路透」事件，当事方发布澄清说明",
    summary:
      "一组来源不明的片场照片在社交平台快速扩散，引发大量猜测。剧组当晚发布说明，对拍摄安排与现场管理作出回应。",
    channelSlug: "ming-xing",
    channelName: "明星动态",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20film%20set%20with%20clapperboard%20and%20vintage%20camera%20on%20warm%20cream%20background%2C%20minimal%20studio%20lighting%2C%20no%20people%2C%20clean%20editorial%20product%20style%20photography%2C%20soft%20shadows%2C%20muted%20warm%20palette&width=800&height=600&seq=bl-cover-1003&orientation=landscape",
    author: "本频道编辑部",
    publishedAt: "2026-09-09 21:40",
    readTime: "3 分钟",
    tags: ["剧组路透", "澄清说明", "隐私保护"],
    views: 152300,
    hot: true,
    editorPick: false,
    content: [
      "9 月 9 日下午起，一组标注为某剧组拍摄现场的照片在多个社交平台流传。由于照片中的场记板信息与拍摄日程存在出入，很快衍生出多种版本的猜测，相关话题在两小时内进入热搜前列。",
      "当晚 21 时，剧组通过官方账号发布说明。说明中提到，网传照片并非该剧正式拍摄内容，而是前期试装与走位测试阶段的现场记录；同时强调剧组一直执行封闭拍摄管理，对于未经授权传播现场影像的行为保留追责权利。",
      "说明还提到，近期确有无关人员在拍摄区域周边长时间逗留，剧组已加强现场秩序维护，并与属地管理方沟通后续安排。剧组呼吁公众不要传播来源不明的现场影像，共同维护正常的创作环境。",
      "事实上，围绕剧组路透的治理近两年持续加强。多个影视基地已上线拍摄区域提示与巡查机制，平台也在压缩未经授权的现场内容传播空间。对于观众来说，耐心等待官方物料，往往能获得更完整的观看体验。",
    ],
  },
  {
    id: "a1004",
    slug: "concert-tickets-sellout-mechanism",
    title: "演唱会门票开售即秒空，主办方详解售票机制",
    summary:
      "一场备受关注的巡演在开票数分钟内售罄，随之而来的是关于购票难的老问题。主办方就分配比例与实名规则给出了解释。",
    channelSlug: "yu-le",
    channelName: "娱乐爆料",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20concert%20stage%20with%20glowing%20warm%20orange%20lights%20and%20silhouette%20of%20empty%20seats%2C%20energetic%20night%20atmosphere%2C%20no%20people%20visible%2C%20cinematic%20bokeh%2C%20editorial%20music%20magazine%20photography&width=800&height=600&seq=bl-cover-1004&orientation=landscape",
    author: "演出观察员",
    publishedAt: "2026-09-09 18:10",
    readTime: "4 分钟",
    tags: ["演唱会", "售票机制", "实名购票"],
    views: 87400,
    hot: false,
    editorPick: true,
    content: [
      "上周，一场巡演的开票页面在开放后数分钟内显示售罄，大量用户反映在排队环节就被挤出。购票难的话题再次被推到台前，也让售票机制的透明度成为讨论焦点。",
      "主办方在回应中表示，本次巡演的可售座位中，约七成通过公开渠道投放，其余部分用于场馆预留、合作渠道与安全通道调整。全部座位实行实名购票与实名入场，票面信息与入场证件需保持一致，转赠功能已在开票前关闭。",
      "针对「黄牛」问题，主办方提到已与平台建立异常订单识别机制，对同一设备、同一支付账户的批量下单进行限制，并在入场环节设置二次核验。若发现信息不符，将按规则处理。",
      "业内人士提醒，与其在非官方渠道高价购票，不如关注主办方后续可能释放的退票回流。多数巡演会在开演前 48 小时开放有限的退票通道，这部分票源通常重新回到官方票池，价格与规则与首次开售一致。",
    ],
  },
  {
    id: "a1005",
    slug: "shortvideo-headline-crackdown",
    title: "短视频平台整治「标题党」，一批账号被限流",
    summary:
      "平台发布新一期内容治理公告，重点针对夸大标题、拼接素材与诱导点击行为，公布了阶段性处置结果。",
    channelSlug: "wang-luo",
    channelName: "网络热议",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20digital%20noise%20and%20glitch%20texture%20in%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20minimal%20tech%20aesthetic%2C%20no%20readable%20text%2C%20soft%20gradient%20light%2C%20editorial%20magazine%20cover%20style&width=800&height=600&seq=bl-cover-1005&orientation=landscape",
    author: "平台观察组",
    publishedAt: "2026-09-09 15:30",
    readTime: "4 分钟",
    tags: ["内容治理", "标题党", "账号限流"],
    views: 64100,
    hot: false,
    editorPick: false,
    content: [
      "近日，多家短视频平台陆续发布新一期内容治理公告。公告显示，本轮治理的重点集中在三类行为：使用与内容不符的夸张标题、拼接无关素材制造悬念，以及通过诱导性话术引导用户点击外链。",
      "根据公告披露的阶段性数据，平台在本轮治理中共处置违规账号数千个，其中大部分被处以限流，少数存在多次违规记录的账号被暂停相关功能。平台同时提到，识别机制已从人工巡查扩展到模型预判，标题与画面一致性成为重要判断维度。",
      "有创作者在采访中表示，治理力度加大后，账号的选题方式确实在调整。「以前封面和标题要尽量抓眼球，现在更在意开头三秒能不能讲清楚信息。」一位生活类博主这样描述变化。",
      "对普通用户来说，治理带来的直接体验变化是信息流里「货不对板」的内容减少。不过也有观点认为，判断标准仍需持续公开，让创作者清楚知道边界在哪里，才能在治理与创作活力之间取得平衡。",
    ],
  },
  {
    id: "a1006",
    slug: "music-festival-lineup-announced",
    title: "音乐节阵容官宣，多组新生代乐队首次同台",
    summary:
      "秋季音乐节密集官宣阵容，多组此前未曾同台的年轻乐队出现在同一张海报上，票务与场地方案同步公布。",
    channelSlug: "ying-shi",
    channelName: "影视综艺",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20outdoor%20music%20festival%20stage%20at%20sunset%20with%20warm%20golden%20light%20and%20empty%20grass%20field%2C%20no%20people%2C%20cinematic%20wide%20composition%2C%20warm%20amber%20and%20olive%20tones%2C%20editorial%20photography&width=800&height=600&seq=bl-cover-1006&orientation=landscape",
    author: "演出观察员",
    publishedAt: "2026-09-09 11:15",
    readTime: "3 分钟",
    tags: ["音乐节", "阵容官宣", "现场演出"],
    views: 42300,
    hot: false,
    editorPick: false,
    content: [
      "进入九月，秋季音乐节的阵容陆续揭晓。与往年相比，今年多场音乐节在阵容编排上更偏向年轻化，多组以现场演出见长的新生代乐队首次出现在同一张海报中，成为讨论度最高的部分。",
      "主办方介绍，本次阵容在舞台分配上做了区分：主舞台以完整乐队编制为主，副舞台则安排了更多融合风格的组合，两天演出的收尾时段均安排了压轴专场，便于观众根据喜好规划行程。",
      "票务方面，多数音乐节延续了实名制购票与分时段入场的方式，并在场地周边增设了接驳车与临时休息区。对于跨城观演的观众，主办方提示提前留意天气与场地公告，现场禁止携带的物品清单已在购票页面公示。",
      "值得关注的是，音乐节的消费带动效应仍在扩大。从往届数据看，跨城观众在餐饮、住宿与周边交通上的支出，往往数倍于门票本身，这也让不少城市把音乐节纳入秋季文旅推广的重点内容。",
    ],
  },
  {
    id: "a1007",
    slug: "variety-editing-dispute",
    title: "综艺节目剪辑争议发酵，节目组承诺公开完整素材",
    summary:
      "一段被指「断章取义」的节目片段引发讨论，嘉宾团队与节目组先后发声，最终以公开原始素材的方式回应质疑。",
    channelSlug: "wang-luo",
    channelName: "网络热议",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20editing%20timeline%20concept%20with%20warm%20cream%20paper%20strips%20and%20soft%20shadow%2C%20minimal%20desk%20flat%20lay%2C%20no%20people%2C%20muted%20warm%20palette%2C%20clean%20editorial%20still%20life%20photography&width=800&height=600&seq=bl-cover-1007&orientation=landscape",
    author: "综艺观察组",
    publishedAt: "2026-09-08 20:50",
    readTime: "4 分钟",
    tags: ["综艺剪辑", "素材公开", "沟通机制"],
    views: 73800,
    hot: false,
    editorPick: false,
    content: [
      "上周末播出的一档综艺节目中，一段时长不到两分钟的对话片段在网络上引发讨论。部分观众认为，片段中的表述在正片语境下容易产生误读，相关话题在播出当晚进入热搜。",
      "次日，节目嘉宾团队通过官方渠道表示，已就剪辑呈现方式与节目组进行沟通。节目组随后回应称，正片受时长限制做过取舍，愿意公开该环节的完整未剪辑素材，供观众在官方账号下自行查看。",
      "这一处理方式获得了相对正面的反馈。有观众在评论区表示，公开原始素材比反复解释更有说服力，也能让后续讨论基于完整信息展开。也有从业者指出，综艺剪辑是二次创作，如何在节奏与真实之间取舍，本身就是行业长期课题。",
      "据节目组透露，完整素材已在官方账号的分集页面更新，正片不会进行调整。节目下一期的播出时间保持不变。",
    ],
  },
  {
    id: "a1008",
    slug: "studio-rights-progress",
    title: "明星工作室晒出维权进展，涉事营销号公开致歉",
    summary:
      "一场持续数月的名誉维权有了新进展，多个账号发布致歉声明并删除不实内容，工作室同步公布了后续处理安排。",
    channelSlug: "ming-xing",
    channelName: "明星动态",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20balanced%20scales%20concept%20made%20of%20warm%20brass%20and%20cream%20paper%2C%20minimal%20studio%20lighting%2C%20no%20people%2C%20soft%20warm%20shadow%2C%20editorial%20magazine%20still%20life%20photography%2C%20muted%20palette&width=800&height=600&seq=bl-cover-1008&orientation=landscape",
    author: "本频道编辑部",
    publishedAt: "2026-09-08 16:25",
    readTime: "3 分钟",
    tags: ["名誉维权", "致歉声明", "网络治理"],
    views: 68900,
    hot: false,
    editorPick: true,
    content: [
      "9 月 8 日，一位艺人的工作室在官方账号公布了此前的维权进展。公告显示，针对数月来在多个平台传播的不实内容，工作室已完成证据固定并启动法律程序，目前已有多个账号主动删除相关内容并发布致歉声明。",
      "工作室在公告中列出了处理方式的三个阶段：先行提示删除、协商公开致歉、以及对拒不配合的账号提起诉讼。公告同时强调，维权范围仅限于内容明显失实的部分，不针对正常的观点讨论与文艺批评。",
      "有长期关注网络名誉权纠纷的从业者表示，此类案件的关键在于证据链的完整性，包括发布时间、传播范围与账号关联关系的固定。近两年，随着平台配合度提高，多数纠纷能在诉讼前通过协商解决。",
      "工作室提醒粉丝理性对待网络信息，不要通过反向攻击的方式回应争议，避免将个人纠纷扩大为群体对立。后续进展工作室将按阶段对外公布。",
    ],
  },
  {
    id: "a1009",
    slug: "film-base-set-tour",
    title: "影视基地开放探班，剧组首次回应置景投入传闻",
    summary:
      "一座大型影视基地首次向媒体开放部分拍摄区域，剧组就此前流传的置景成本与周期问题作出说明。",
    channelSlug: "ying-shi",
    channelName: "影视综艺",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20traditional%20chinese%20courtyard%20architecture%20model%20with%20warm%20wood%20textures%20and%20cream%20stone%2C%20soft%20daylight%2C%20no%20people%2C%20editorial%20architecture%20photography%2C%20warm%20muted%20palette%2C%20clean%20composition&width=800&height=600&seq=bl-cover-1009&orientation=landscape",
    author: "影视观察组",
    publishedAt: "2026-09-08 10:40",
    readTime: "4 分钟",
    tags: ["影视基地", "置景", "制作幕后"],
    views: 35600,
    hot: false,
    editorPick: false,
    content: [
      "上周，一座位于华东的大型影视基地首次向媒体开放部分拍摄区域。开放日当天，剧组工作人员带着参观者从主场景走到道具库，沿途介绍了置景的搭建流程与材料选择。",
      "针对此前网络上流传的「置景投入过高」说法，剧组美术负责人作出了说明。他表示，主场景中约六成结构采用可回收的模块化材料，搭建完成后会拆解保存，用于后续同系列项目。「看起来像一次性投入，实际是分摊到多个项目里的。」",
      "在道具库中可以看到，工作人员对每件道具建立了编号与出入库记录，部分精细道具由专门的手工团队制作。负责人提到，随着拍摄周期缩短，置景的预制比例明显提高，这也是控制成本的主要方式。",
      "基地管理方表示，后续将定期开放探班名额，通过预约方式面向公众与行业从业者，希望借此减少关于制作环节的信息差。",
    ],
  },
  {
    id: "a1010",
    slug: "night-economy-performance-market",
    title: "城市夜经济升温，演出市场带动周边消费",
    summary:
      "多个城市公布秋季演出与夜间市集安排，从公开数据看，演出场次增加正在带动周边餐饮与交通消费。",
    channelSlug: "she-hui",
    channelName: "社会热点",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20city%20street%20at%20night%20with%20warm%20amber%20lantern%20glow%20and%20blurred%20lights%2C%20empty%20pelestrian%20walkway%2C%20no%20people%2C%20cinematic%20warm%20tones%2C%20editorial%20urban%20photography&width=800&height=600&seq=bl-cover-1010&orientation=landscape",
    author: "城市观察组",
    publishedAt: "2026-09-07 19:00",
    readTime: "4 分钟",
    tags: ["夜经济", "演出市场", "消费观察"],
    views: 39800,
    hot: false,
    editorPick: false,
    content: [
      "进入秋季，多个城市陆续公布了本季的演出排期与夜间市集安排。从已公开的信息看，剧院、livehouse 与户外场地的场次密度较去年同期有所提升，部分场次在工作日晚间就已满座。",
      "演出带来的消费外溢效应较为明显。以某剧场周边的商户反馈为例，演出日当晚的客流高峰普遍比平日推迟约一小时，演出结束后的半小时内，周边餐饮与便利店的到店人数出现集中增长。",
      "交通方面，多个城市在演出日延长了部分地铁线路的运营时间，并在线路图与售票页面提供散场提示。有车站工作人员介绍，散场时段的单向客流特征明显，因此会提前开放部分备用出口。",
      "也有从业者提醒，夜经济的可持续性取决于内容供给的稳定。仅靠短期的密集排期，容易出现观众审美疲劳；把演出与街区、文创与餐饮串联起来，形成可重复的消费动线，才更有利于长期发展。",
    ],
  },
  {
    id: "a1011",
    slug: "classic-series-reboot",
    title: "经典剧集宣布重启，原班主创回归引发回忆杀",
    summary:
      "一部播出多年的经典剧集确认启动新篇章，多位主创回归的消息公布后，相关话题迅速进入热搜前列。",
    channelSlug: "yu-le",
    channelName: "娱乐爆料",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20retro%20film%20reel%20and%20warm%20cream%20paper%20photos%20scattered%20on%20wooden%20desk%2C%20nostalgic%20warm%20light%2C%20no%20people%2C%20editorial%20still%20life%20photography%2C%20muted%20sepia%20palette&width=800&height=600&seq=bl-cover-1011&orientation=landscape",
    author: "本频道编辑部",
    publishedAt: "2026-09-07 14:20",
    readTime: "3 分钟",
    tags: ["经典重启", "原班主创", "片单公布"],
    views: 91200,
    hot: true,
    editorPick: false,
    content: [
      "9 月 7 日，一部播出多年的经典剧集通过官方账号宣布启动新篇章。公告以一段三十秒的先导影像呈现，画面中没有台词，只出现了旧版片头中的标志性场景与日期，末尾标注「新篇章，敬请期待」。",
      "随后公布的主创名单显示，多位原班编剧与摄影指导将回归新篇章，部分主演也已进入接洽阶段。公告并未透露新篇章的集数与上线时间，仅表示剧本已进入最终打磨。",
      "消息公布后，相关话题在半小时内进入热搜前列，大量观众在评论区回忆起当年的播出场景。也有观众表达了谨慎的期待，希望新篇章不要过度依赖情怀，而是拿出经得起比较的内容质量。",
      "从行业经验看，经典 IP 的重启往往面临「还原」与「创新」的双重压力。制作方若能在保留核心气质的同时，用当下的叙事方式重新组织故事，通常更容易被新老观众同时接受。",
    ],
  },
  {
    id: "a1012",
    slug: "teen-mode-upgrade",
    title: "平台上线「青少年模式」升级版，家长可远程管理",
    summary:
      "多个内容平台在秋季开学前完成青少年模式的版本更新，新增远程管理与使用时长联动功能，并公开了设置路径。",
    channelSlug: "she-hui",
    channelName: "社会热点",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20soft%20warm%20study%20desk%20with%20open%20cream%20notebook%20and%20pencil%2C%20gentle%20morning%20light%2C%20no%20people%2C%20minimal%20editorial%20still%20life%2C%20muted%20warm%20palette%2C%20calm%20composition&width=800&height=600&seq=bl-cover-1012&orientation=landscape",
    author: "平台观察组",
    publishedAt: "2026-09-06 17:45",
    readTime: "3 分钟",
    tags: ["青少年模式", "家长管理", "开学季"],
    views: 47200,
    hot: false,
    editorPick: true,
    content: [
      "赶在秋季开学前，多个内容平台完成了「青少年模式」的版本更新。与早期版本相比，本次升级更强调家长端的参与，新增了远程管理入口与使用时长联动功能。",
      "根据平台公开的说明，家长可在绑定账号后，通过独立的家长端页面查看使用时长、调整可访问内容范围，并设置单日时长上限。部分平台还把设置入口直接放在「我的」页面的固定位置，减少了此前的多层跳转。",
      "有家长在体验后表示，远程管理确实比在孩子设备上反复设置更方便，但也希望内容分级能更细致。「同一个标签下的内容差别其实很大，希望筛选能再具体一点。」",
      "平台方回应称，后续会继续优化推荐策略，让青少年模式下的内容池更加稳定，同时保持对新增内容的持续审核。相关设置路径已在帮助中心同步更新。",
    ],
  },
];